import {RefObject} from 'react';

/**
 * Determines if script is loaded
 * @param {string} src - path to the script
 * @returns {boolean} is loaded
 */
export const isScriptAlreadyAdded = (src: string) =>
    Boolean(document.querySelector(`script[src="${src}"]`));

/**
 * Insert script into document body
 * @param {string} src - script source url
 * @param {boolean} remount - remove tag if it exists an add it again
 * @param {function} callback - onLoad callback
 * @returns {HTMLScriptElement} - Inserted script
 */
export const insertScript = (src: string, remount = true, callback): HTMLScriptElement => {
    const existingTag = document.querySelector(`script[src="${src}"]`) as HTMLScriptElement;
    if (existingTag && remount) existingTag.remove();

    const script = existingTag || document.createElement('script');

    script.type = 'text/javascript';
    script.src = src;
    if (callback) script.onload = callback;

    document.body.insertBefore(script, document.body.firstChild);

    return script;
};

/**
 * Function for close mobile keyboard
 * It's a fix for the iOS keyboard non auto-hidden
 * @param {RefObject<HTMLInputElement>} element - React Ref element
 */
export const closeMobileKeyboard = (element: RefObject<HTMLInputElement>) => {
    const {current} = element;
    if (current !== null) {
        current.hidden = false;
        current.focus();
        current.blur();
        current.hidden = true;
    }
};

/**
 * Is react element.
 * @param {HTMLElement} element - element which will be checked on react owning
 * @return {boolean} - is react element
 */
export const isReactElement = (element: HTMLElement): boolean =>
    Object.keys(element).some(key => key.includes('__react'));

/**
 * Remove all dynamic yield elements from document
 */
export const removeDYFromDocument = () => {
    const dyElements = document.querySelectorAll('[data-dy-embedded-object="true"]');
    // @ts-ignore
    Array.of(...dyElements).forEach((dyElement: HTMLElement) => {
        if (!isReactElement(dyElement)) {
            // @ts-ignore
            dyElement.parentNode.removeChild(dyElement);
        }
    });
};

/**
 * Returns all height for criteo notifications if they are was displayed
 * @return {number} - summary height
 */
export const getHeightFromCriteoNotifications = (): number => {
    let height = 0;
    document.querySelectorAll('.criteo_header').forEach((element): void => {
        height += (element as HTMLElement).offsetHeight;
    });
    return height;
};
